import React, { useEffect, useState } from "react";
import {
  Alert,
  Card,
  Row,
  Col,
  Accordion,
  Button, 
  Table, 
  Modal,
} from "react-bootstrap";
import { getSufferingsByCaseId, storeSuffering } from "@services/sufferings-data";
import SufferingForm from "./suffering-form";
import moment from "moment";

export const SufferingData = (props) => {
  return (
      <>
        <Card>
          <Card.Header>
            <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey={props.eventKey}
            >
              Datos Padecimiento
            </Accordion.Toggle>
            <i className={`fa ${props.icon}`} style={{position:"absolute", right:"0", marginRight:"15px", marginTop:"10px" }}></i>
            <i className={`fa ${props.icone}`} style={{position:"absolute", right:"0", marginRight:"35px", marginTop:"10px" }}></i>
          </Card.Header>
          <Accordion.Collapse eventKey={props.eventKey}>
            <Card.Body>
              <ContentSufferingData {...props} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </>
  );
};

export const ContentSufferingData = (props) => {
  return (
      <>
        <Alert
            variant="dark"
            className="text-center"
            style={{ fontSize: "14px" }}
        >
          Datos Padecimiento
        </Alert>

        <Card>
          <Card.Body>
            <FormSufferingData {...props} />
          </Card.Body>
        </Card>
      </>
  );
};

export const FormSufferingData = (props) => {
  const [currSuffering, setCurrSuffering] = useState({
    clientCertificate: "",
    atentionIden: "",
    identificator: "",
    opinionIden: "",
    icd: "",
    icdDescription: "",
    cpt: "",
    cptDescription: "",
  });
  const [sufferings, setSufferings] = useState([]);
  const [axaCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const { id } = props.data;
  const { bindSubmitForm } = props;

  const getSufferings = async () => {
    const sufferingsResponse = await getSufferingsByCaseId(id);
    setSufferings(sufferingsResponse?.data);
  }

  // Función para limpiar el objeto currSuffering
  const clearSuffering = () => {
    setCurrSuffering({
      clientCertificate: "",
      atentionIden: "",
      identificator: "",
      opinionIden: "",
      icd: "",
      icdDescription: "",
      cpt: "",
      cptDescription: "",
    });
  };

  const handleSubmitForm = async (values, formikBag) => {
    values.caseId = id;
    await storeSuffering(values, id);
    await getSufferings();
    setShowModal(false);
    
    // Limpiar currSuffering después de guardar
    clearSuffering();

    formikBag.resetForm();
    formikBag.setSubmitting(false);
  };

  const handleEdit = (suffering) => {
    setCurrSuffering(suffering);
    setShowModal(true);
  };

  const handleAddNew = () => {
    clearSuffering(); // Utilizar la función de limpieza
    setShowModal(true);
  };

  useEffect(() => {
    if (id) {
      getSufferings();
    }
  }, [props.data]);

  return (
    <>
      {!props.hideForm && <SufferingForm
          initialValues={currSuffering}
          axaCategories={axaCategories}
          onSubmit={handleSubmitForm}
          disabledAll={props.disabledAll}
          bindSubmitForm={bindSubmitForm}
      />}

      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th>Atención</th>
            <th>Folio</th>
            <th>Dictamen</th>
            <th>ICD (Clave)</th>
            <th>ICD descripción</th>
            <th>CPT (Clave)</th>
            <th>CPT descripción</th>
            <th>Fecha hora (DD/MM/AAAA HH:MM:SS)</th>
            <th>Usuario</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          {sufferings?.map((suffering, idx) => (
            <tr key={idx}>
              <td>{suffering.atentionIden}</td>
              <td>{suffering.identificator}</td>
              <td>{suffering.opinionIden}</td>
              <td>{suffering.icd}</td>
              <td>{suffering.icdDescription}</td>
              <td>{suffering.cpt}</td>
              <td>{suffering.cptDescription}</td>
              <td>{suffering.updatedAt ? moment(suffering.updatedAt).format('DD/MM/YYYY H:m:s') : ''}</td>
              <td>{suffering.userName}</td>
              <td>
                <Button 
                  className="btn btn-default" 
                  onClick={() => handleEdit(suffering)}
                  disabled={props.disabledAll}
                >
                  <i className="fas fa-pencil-alt"></i>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <SufferingModal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          // Limpiar el objeto cuando se cierra el modal sin guardar
          clearSuffering();
        }}
        suffering={currSuffering}
        onSubmit={handleSubmitForm}
        axaCategories={axaCategories}
        disabledAll={props.disabledAll}
      />
    </>
  );
};

const SufferingModal = ({ show, onHide, suffering, onSubmit, axaCategories, disabledAll }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {suffering.id ? "Editar Padecimiento" : "Agregar Padecimiento"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SufferingForm
          initialValues={suffering}
          axaCategories={axaCategories}
          onSubmit={onSubmit}
          disabledAll={disabledAll}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
